<template>
  <div class="stores-section q-mt-xl">
    <div class="row items-center q-mb-lg">
      <div class="col">
        <h2 class="text-h4 text-weight-bold featured-heading">Popular Stores</h2>
        <div class="heading-underline"></div>
      </div>
      <div class="col-auto">
        <q-btn to="/stores" flat color="primary" class="view-all-btn" icon-right="arrow_forward" label="View All" no-caps />
      </div>
    </div>
    <div v-if="loading" class="row q-col-gutter-md">
      <div class="col-md-2 col-sm-3" v-for="i in 12" :key="i">
        <q-skeleton height="120px" square />
      </div>
    </div>
    <div v-else-if="error" class="text-center q-pa-xl bg-grey-2 rounded-borders">
      <q-icon name="error_outline" size="3rem" color="negative" />
      <p class="text-h6 text-negative q-mt-md">{{ error }}</p>
      <q-btn label="Try Again" color="primary" @click="$emit('refresh')" class="q-mt-md" no-caps />
    </div>
    <div v-else-if="stores.length === 0" class="text-center q-pa-xl bg-grey-2 rounded-borders">
      <q-icon name="info" size="3rem" color="grey-7" />
      <p class="text-h6 text-grey-7 q-mt-md">No stores available at the moment</p>
    </div>
    <div v-else class="row q-col-gutter-md">
      <div class="col-4 col-sm-3 col-md-2" v-for="(store, index) in stores" :key="store.id || index">
        <q-card 
          class="store-card text-center h-100 cursor-pointer" 
          flat 
          bordered
          @click="navigateToStore(store.url_slug)"
          v-ripple
        >
          <q-img
            :src="store.logo_url || '/images/placeholder.png'"
            :alt="store.name"
            height="90px"
            fit="contain"
            loading="lazy"
            @error="onImgError"
          >
            <template v-slot:loading>
              <q-spinner-dots color="grey-5" />
            </template>
          </q-img>
          <q-card-section>
            <div class="text-subtitle2 text-weight-medium">{{ store.name }}</div>
            <div class="text-caption text-grey-7">
              {{ store.coupons_count || 0 }} coupons
            </div>
          </q-card-section>
          <q-card-actions align="center">
            <q-btn 
              flat 
              color="primary" 
              label="View Offers" 
              size="sm" 
              no-caps
              @click.stop="navigateToStore(store.url_slug)"
            />
          </q-card-actions>
        </q-card>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  stores: { type: Array, default: () => [] },
  loading: Boolean,
  error: String,
});
const emit = defineEmits(['refresh', 'navigate-to-store', 'img-error']);
const navigateToStore = (slug) => emit('navigate-to-store', slug);
const onImgError = (e) => emit('img-error', e);
</script>
